import { prefixRelativeUrl } from '../util.js';
import 'bootstrap-autocomplete';
$(function () {
    $(document).on('click', '#search-next-page', (e) => {
        e.preventDefault();
        $.get({
            url: e.currentTarget.href,
            success: (data) => {
                var $data = $(data);
                var $src = $('.hit-area');
                $src.find('.hits').append($data.find('.hits li'));
                $src.find('.paging').replaceWith($data.find('.paging')[0]);
            }
        });
    });
    $('.feedback .btn').on('click', function () {
        var message = $('.feedback textarea').val();
        const $btn = $(this).prop('disabled', true);
        const btnText = $btn.text();
        $btn.html(
            `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Skickar...`
        );

        $.ajax({
            method: 'post',
            url: prefixRelativeUrl(window.location.pathname + '/feedback'),
            data: { message: message }
        })
            .done(function (data) {
                if (data.success) {
                    $('.thankyou').addClass('show');
                } else {
                    $('.feedback .error').html(data.message).removeClass('d-none');
                    $btn.html(btnText);
                    $btn.prop('disabled', false);
                }
            })
            .fail(function () {
                $('.feedback .error')
                    .html('Något gick fel när formuläret skulle skickas')
                    .removeClass('d-none');
                $btn.html(btnText);
                $btn.prop('disabled', false);
            });
    });
    $('#search-lg-input, #search-input').on('autocomplete.select', function (evt, item) {
        $(this).val(item.query);
        $(this).parent('form').submit();
    });
    $('#search-lg-input,#search-input').autoComplete({
        minLength: 2,
        noResultsText: 'Inga förslag',
        resolverSettings: {
            queryKey: 'prefix',
            url: prefixRelativeUrl('/find_v2/_autocomplete')
        },
        formatResult: (item) => {
            return {
                value: item.query,
                text: item.query
            };
        },
        events: {
            searchPost: (data, jqElement) => {
                return data.hits;
            }
        }
    });
    $('.button-wrapper').on('click', function () {
        if ($(this).hasClass('selected')) return;
        $(this).addClass('selected');
        $('.button-wrapper').not(this).addClass('hidden');
    });
});
